/* eslint-disable */

<template>
  <div>

    <vue-sortable :options="options" @drag:start="startedDrag" @drag:stop="stoppedDrag" @sortable:sort="sort">
      <div class="vx-row " :class="{'cursor-drag' : draggingCard === true}">
        <div class="vx-col lg:w-3/12 md:w-3/12 sm:w-5/5">
          <vx-card class="mb-base">
            <h3 class="font-bold mb-4">Extensions</h3>
            <vue-draggable-container id="wordBank" class="wordBank">
              <h5 class="dragBlock my-2 font-semibold cursor-pointer" v-for="control in controls" :key="control">{{control}}</h5>
            </vue-draggable-container>
          </vx-card>
        </div>
        <div class="vx-col lg:w-9/12 md:w-9/12 sm:w-5/5">
          <vx-card class="mb-base">
            <div class="fourth-sim pt-0">
              <div class="vx-row mb-4">
                <div class="vx-col w-6/12 flex items-center">
                  <img draggable="false" src="https://rapidsimulations.com/simulations/1/images/smartphone_1.png"
                       width="50">
                  <h2 class="font-bold">Company Managed Smart Phone</h2>
                </div>
                <div class="vx-col w-6/12 flex items-center">
                  <img draggable="false" src="https://image.flaticon.com/icons/svg/969/969342.svg" width="50"
                       class="mr-2">
                  <h2 class="font-bold">Data Center Terminal Server</h2>
                </div>
              </div>
              <div class="vx-row border-white rounded p-2 ">
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg "
                                           id="inputPhone0">

                  </vue-draggable-container>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg "
                                           id="inputServer0">

                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white rounded p-2 ">
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg "
                                           id="inputPhone1">

                  </vue-draggable-container>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg "
                                           id="inputServer1">

                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white rounded p-2 ">
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg "
                                           id="inputPhone2">

                  </vue-draggable-container>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg "
                                           id="inputServer2">

                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white rounded p-2 ">
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg "
                                           id="inputPhone3">

                  </vue-draggable-container>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg "
                                           id="inputServer3">

                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white rounded p-2 ">
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg "
                                           id="inputPhone4">

                  </vue-draggable-container>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg "
                                           id="inputServer4">

                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white rounded p-2 ">
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg "
                                           id="inputPhone5">

                  </vue-draggable-container>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg "
                                           id="inputServer5">

                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white rounded p-2 ">
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg "
                                           id="inputPhone6">

                  </vue-draggable-container>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg "
                                           id="inputServer6">

                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white rounded p-2 ">
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg "
                                           id="inputPhone7">

                  </vue-draggable-container>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg "
                                           id="inputServer7">

                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row border-white rounded p-2 ">
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg "
                                           id="inputPhone8">

                  </vue-draggable-container>
                </div>
                <div class="vx-col w-6/12">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg "
                                           id="inputServer8">

                  </vue-draggable-container>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </vue-sortable>
  </div>
</template>

<script>

import draggable from 'vuedraggable'
import Prism from 'vue-prism-component'
import shuffle from 'shuffle-array'

export default {
  data () {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,
      //last_drag_error: false,

      smart_phone: [
        'Screen Lock',
        'Strong Password',
        'Device Encryption',
        'Remote Wipe',
        'GPS Tracking'
      ],

      data_center: [
        'Popup Blocker',
        'Strong Password',
        'Antivirus',
        'Host Based Firewall',
        'Sniffer',
        'Man Trap',
        'Proximity Badge'
      ],

      controls: [
        'Screen Lock',
        'Strong Password',
        'Device Encryption',
        'Remote Wipe',
        'GPS Tracking',
        'Popup Blocker',
        'Strong Password',
        'Antivirus',
        'Host Based Firewall',
        'Sniffer',
        'Man Trap',
        'Proximity Badge'
      ],

      options: {
        draggable: '.dragBlock',
        dropzone: '.dropzoneStandard'

      }
    }
  },
  methods: {
    startedDrag (x) {
      x.data.source.className += ' currently-dragging-standard'
      this.draggingCard = true

    },
    stoppedDrag () {
      this.draggingCard = false
    },
    sort (x) {
      const overContainer = x.data.dragEvent.data.overContainer
      const sourceContainer = x.data.dragEvent.data.sourceContainer
      if (overContainer && overContainer.id !== 'wordBank' && overContainer.children) {
        if (overContainer.children.length > 0 && overContainer.id !== sourceContainer.id) {
          //this.drag_error()
          x.cancel()
        }
      }
    },
    /*  drag_error () {
        const now = new Date().getTime()
        if (this.last_drag_error === false || (now - this.last_drag_error) > 7500) {
          this.last_drag_error = now
          this.$vs.notify(
            {
              color: 'warning',
              title: 'Maximum One Answer Per Input',
              position: 'top-center',
              icon: 'feather',
              iconPack: 'icon-alert-circle',
            })
        }
      }, */
    markSimulation () {

      let total_score = 0

      this.smart_phone.forEach(function (x) {
        for (let i = 0; i < 8; i++) {
          if (document.getElementById(`inputPhone${i}`).textContent === x) {
            total_score++
            document.getElementById(`inputPhone${i}`).style.borderColor = '#28C76F'
            document.getElementById(`inputPhone${i}`).style.backgroundColor = '#28C76F'
          }
        }
      })

      this.data_center.forEach(function (x) {
        for (let i = 0; i < 9; i++) {
          if (document.getElementById(`inputServer${i}`).textContent === x) {
            total_score++
            document.getElementById(`inputServer${i}`).style.borderColor = '#28C76F'
            document.getElementById(`inputServer${i}`).style.backgroundColor = '#28C76F'
          }
        }
      })


      if (total_score === this.dataLocal.legacy.total_score) {
        return this.$emit('simulation_full_correct', total_score)
      }

      this.$emit('simulation_getting_there', total_score)

    }

  },
  components: {
    draggable,
    Prism,
    shuffle
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  created () {
    this.controls = shuffle(this.controls)
  }

}
</script>

